import { Component } from '@angular/core';

@Component({
    selector: 'redispatch-contact-data-page',
    templateUrl: './contact-data-page.component.html',
    styleUrls: [
        './contact-data-page.component.scss',
    ],
    standalone: false,
})
export class ContactDataPageComponent {

    constructor() { }

}
